import type { RouteRecordRaw } from 'vue-router';

import sitesListRoute from './sites-list';
import singleSiteRoute from './site-details';
import stationSchedule from './station-schedule';
import businessUnitUpdate from './business-unit-update';
import station from './station';
import siteSettings from './site-settings';
import siteSettingsAgilysys from './site-settings/agilysys';
import nextepUpdate from './integration-update/nextep';
import appConfig from './app-config';
import centricHubConfig from './integration-update/centric-hub';

export default [
  sitesListRoute,
  singleSiteRoute,
  stationSchedule,
  businessUnitUpdate,
  siteSettings,
  siteSettingsAgilysys,
  station,
  nextepUpdate,
  appConfig,
  centricHubConfig,
] as RouteRecordRaw[];

export * from './stores';
